import React, { useEffect, useState } from 'react';
import CustomTable from '../../Table/CustomTable';
import { eventColumns } from './Columns';
import {
  useGetPersonnel,
  useInstrumentEquipments,
  useInstrumentEvents,
  useInstrumentSettings
} from '../../../util/db';
import { SETTING_TYPE } from '../TabSettings/DefineCategories';
import moment from 'moment';
import { Col, Form, Row } from 'react-bootstrap';
import { useAuth } from '../../../util/auth';
import { hasPermission } from '../utils';
import { RULES, SCREEN } from '../../../util/Constant';
import { alphaNumericSorter } from '../../../util/util';

const EventAtGlance = () => {
  const auth = useAuth();
  const { data: rawEvents = [] } = useInstrumentEvents();
  const { data: instruments = [] } = useInstrumentEquipments();
  const { data: personnel = [] } = useGetPersonnel();
  const { data: instrumentSettingsEventStatus = [] } = useInstrumentSettings(
    SETTING_TYPE.EVENT_STATUS
  );
  const { data: allLocations = [] } = useInstrumentSettings(SETTING_TYPE.INSTRUMENT_LOCATION);
  const { data: instrumentSettingsEventType = [] } = useInstrumentSettings(SETTING_TYPE.EVENT_TYPE);
  const [instrumentFilters, setInstrumentFilters] = useState();
  const [responsibleParty, setResponsibleParty] = useState();
  const [permissionData, setPermissionData] = useState(null);

  useEffect(() => {
    if (Array.isArray(personnel) && personnel.length > 0) {
      const matchingUser = personnel.find((person) => person.email === auth.user.email);
      if (matchingUser) {
        if (auth.permissionData) setPermissionData(auth.permissionData[matchingUser.permission]);
      }
    }
  }, [personnel]);

  const handleLocationChange = (event) => {
    if (event.target.value) {
      const instrumentIds = instruments
        .filter((i) => i.location == event.target.value)
        .map((i) => i.id);
      setInstrumentFilters(instrumentIds);
    } else {
      setInstrumentFilters(undefined);
    }
  };

  const now = moment();
  const events = rawEvents
    .map((row) => {
      const dataInstrument = instruments.find((item) => item.id === row.instrumentName);
      const dataStatus = instrumentSettingsEventStatus.find((item) => item.id === row.status);
      const dataType = instrumentSettingsEventType.find((item) => item.id === row.eventType);
      const responsibleParty = personnel.find((item) => item.id === row.responsibleParty);
      const location = allLocations.find((item) => item.id === dataInstrument?.location);
      return {
        ...row,
        location: location?.name,
        instrumentId: dataInstrument?.id,
        instrumentName: dataInstrument?.name,
        status: dataStatus?.name,
        eventType: dataType?.name,
        responsiblePartyName: responsibleParty?.name
      };
    })
    .filter((row) => {
      if (!instrumentFilters) {
        return true;
      }
      return instrumentFilters.includes(row.instrumentId);
    })
    .filter((row) => {
      if (!responsibleParty) {
        return true;
      }
      return row.responsibleParty === responsibleParty;
    });
  const pastDueRows = events.filter((event) => {
    const dueDateMillis = event.dateDue?.seconds ? event.dateDue.seconds * 1000 : null;
    return (
      dueDateMillis &&
      dueDateMillis < now.startOf('day').valueOf() &&
      event.status !== 'Complete' &&
      event.status !== 'In Progress'
    );
  });
  const inProgressRows = events.filter((event) => event.status === 'In Progress');
  const thirtyDaysFromNow = moment().add(30, 'days').endOf('day').valueOf();
  const next30DaysRows = events.filter((event) => {
    const dueDateMillis = event.dateDue?.seconds ? event.dateDue.seconds * 1000 : null;
    return (
      dueDateMillis &&
      dueDateMillis >= now.startOf('day').valueOf() &&
      dueDateMillis <= thirtyDaysFromNow &&
      event.status !== 'Complete' &&
      event.status !== 'In Progress'
    );
  });
  return (
    <>
      {hasPermission(permissionData, SCREEN?.INSTRUMENT_EVENTS, RULES.VIEW) ? (
        <>
          <h2>At a glance</h2>
          <div className="grid-view">
            <div className="filter">
              <p>
                <strong>Filter data by:</strong>
              </p>
              <div>
                <Row>
                  <Form.Group as={Col} controlId="location">
                    <Form.Label>Location</Form.Label>
                    <Form.Select onChange={(event) => handleLocationChange(event)}>
                      <option value="">All locations</option>
                      {allLocations.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                  <Form.Group as={Col}>
                    <Form.Group as={Col}>
                      <Form.Label>Responsible Party</Form.Label>
                      <Form.Select onChange={(event) => setResponsibleParty(event.target.value)}>
                        <option value="">All Responsible Party</option>
                        {personnel.sort(alphaNumericSorter).map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Form.Group>
                  <Form.Group as={Col}></Form.Group>
                  <Form.Group as={Col}></Form.Group>
                </Row>
              </div>
            </div>
            <h3>Past Due</h3>
            <CustomTable
              numberOfRows={pastDueRows?.length > 20 ? 20 : pastDueRows?.length}
              data={pastDueRows}
              header={eventColumns}
              allowScroll={pastDueRows?.length > 20}
            />
            <h3>In Progress</h3>
            <CustomTable
              numberOfRows={inProgressRows?.length > 20 ? 20 : inProgressRows?.length}
              data={inProgressRows}
              header={eventColumns}
              allowScroll={inProgressRows?.length > 20}
            />
            <h3>Next 30 days</h3>
            <CustomTable
              numberOfRows={next30DaysRows?.length > 20 ? 20 : next30DaysRows?.length}
              data={next30DaysRows}
              header={eventColumns}
              allowScroll={next30DaysRows?.length > 20}
            />
          </div>
        </>
      ) : (
        <> </>
      )}
    </>
  );
};

export default EventAtGlance;
